import React, { Fragment, useState, useEffect } from 'react'
import styled from 'styled-components'

import {
    Tabs,
    message,
} from 'antd'

import HQ from '../../utils/Space.HQ'

import Page from '../../components/Page'

import Publish from './Field.Publish'
import Loader from './Loader'

import TabBanner from './Tab.Banner'
import TabConcept from './Tab.Concept'
import TabRecommend from './Tab.Recommend'
import TabReview from './Tab.Review'

import TabMeta from '../post/Tab.Meta'

const { TabPane } = Tabs

const TABS = 
[
    {
        tab: 'แบนเนอร์',
        key: 'banner',
    },
    {
        tab: 'แนวคิด',
        key: 'concept',
    },
    {
        tab: 'โครงการแนะนำ',
        key: 'recommend',
    },
    {
        tab: 'เสียงจากลูกบ้าน',
        key: 'review',
    },
    {
        tab: 'เมต้า',
        key: 'meta',
    },
]

// const VALIDATIONS = 
// {
    
// }

const Container = styled.div`
    @media (min-width: 768px)
    {
        display: flex;

        flex-direction: row;
        flex-wrap: nowrap;
    }
`

const Left = styled.div`
    flex-grow: 1;
`

const Right = styled.div`
    flex-grow: 1;
    flex-shrink: 0;

    max-width: 260px;
    padding: 8px;
`

function Comp ()
{
    const [ action, setAction ] = useState(null)
    const [ tab, setTab ] = useState(TABS[0].key)

    const [ original, setOriginal ] = useState({ })
    const [ current,  setCurrent ] = useState({ })

    // const [ validations, setValidations ] = useState(VALIDATIONS)
    const [ temps, setTemps ] = useState([ ])
    
    // const invalid = !action && HQ.Document.getInvalidFields(current, validations).length > 0
    const changed = !action && HQ.Document.getChangeds(original, current).length > 0

    const canSave = !!changed && !action

    let ready = action !== 'loading'
    let disabled = !!action

    function handleMount ()
    {
        setOriginal({ })
        setCurrent({ })

        setTemps([])
        // setValidations(VALIDATIONS)
        setAction(`loading`)

        const unsubscribes = []
        const promises = []

        promises.push(
            HQ.Query.home (function ({ original, current })
            {
                if (!!original)
                {
                    setOriginal (original)
                }

                if (!!current)
                {
                    setCurrent (current)
                    setAction (null)
                }
            })
        )

        Promise.all(promises).then(function (us)
        {
            us.forEach(function (u)
            {
                unsubscribes.push(u)
            })
        })

        return function ()
        {
            unsubscribes.filter(u => !!u).forEach(u => u())
        }
    }

    function handleChange (name, value)
    {
        setCurrent ({ ...current, [name]: value })
    }

    function handleUploading (uploading)
    {
        setAction(!!uploading ? 'uploading' : null)
    }

    function handleCreateTemp (temp)
    {
        if (!!temp)
        {
            // console.log(temp)
            setTemps([ ...temps, temp ])
        }
    }

    async function handleSave ()
    {
        const _editor = window.localStorage.getItem('editorID')
      
        const banner = current.banner || {}
        const concept = current.concept || {}
        const recommend = current.recommend || {}
        const review = current.review || {}
        const meta = current.meta || {}

        const data =
        {
            banner,
            concept,
            recommend,
            review,
            meta,

            _editor,
        }

        setAction('saving')

        try
        {
            const id = 'home'
            const result = await HQ.Update.save ({ id, data, temps })

            if (result.error)
            {
                setAction(null)
                // setValidations(result.error.validations || { })

                message.error('พบข้อผิดพลาดระหว่างการบันทึก กรุณาตรวจสอบข้อมูลและบันทึกอีกครั้ง')
            }
            else
            {
                setAction(null)
                // setValidations({ })
                setTemps([ ])

                message.success('บันทึกเรียบร้อย')
            }
        }
        catch (err)
        {
            setAction(null)
            message.error('พบข้อผิดพลาดระหว่างการบันทึก กรุณาตรวจสอบข้อมูลและบันทึกอีกครั้ง')
        }
    }

    async function handlePublish ()
    {
        setAction('publishing')

        try
        {
            await HQ.Update.publish ([ 'home' ])

            setAction(null)

            message.success('แผยแพร่เรียบร้อย')
        }
        catch (err)
        {
            setAction(null)
            message.error('พบข้อผิดพลาดระหว่างการเผยแพร่ กรุณาตรวจสอบข้อมูลและเผยแพร่อีกครั้ง')
        }
    }

    useEffect (handleMount, [ ])

    const status = current.status || 'published'
    const publishedAt = current.publishedAt

    return (
        <Page title="จัดการข้อมูลหน้าหลัก" >
            <Container>
                <Left>
                    <Tabs 
                        type="line"
                        activeKey={tab}
                        onChange={setTab}
                        tabBarStyle={{ marginBottom: 0 }}
                    >
                        {
                            TABS.map(function (tab)
                            {
                                return <TabPane disabled={disabled} {...tab} />
                            })
                        }
                    </Tabs>

                    {
                        !!ready &&
                        <Fragment>
                            {
                                tab === 'banner' && 
                                <TabBanner 
                                    data={current.banner}
                                    action={action}
                                    onChange={handleChange}
                                    onUploading={handleUploading}
                                    createTemp={handleCreateTemp}
                                />
                            }
                            {
                                tab === 'concept' && 
                                <TabConcept 
                                    data={current.concept}
                                    action={action}
                                    onChange={handleChange}
                                    onUploading={handleUploading}
                                    createTemp={handleCreateTemp}
                                />
                            }
                            {
                                tab === 'recommend' && 
                                <TabRecommend 
                                    data={current.recommend}
                                    action={action}
                                    onChange={handleChange}
                                />
                            }
                            {
                                tab === 'review' && 
                                <TabReview 
                                    data={current.review}
                                    action={action}
                                    onChange={handleChange}
                                    onUploading={handleUploading}
                                    createTemp={handleCreateTemp}
                                />
                            }
                            {
                                tab === 'meta' && 
                                <TabMeta 
                                    data={current.meta}
                                    action={action}
                                    onChange={value => handleChange ('meta', value)}
                                    onUploading={handleUploading}
                                    createTemp={handleCreateTemp}
                                />
                            }
                        </Fragment>
                    }
                    {!ready && <Loader />}
                </Left>
                <Right>
                    <Publish 
                        action={action}
                        changed={changed}
                        canSave={canSave}
                        status={status}
                        publishedAt={publishedAt}
                        onPublish={handlePublish}
                        onSave={handleSave}
                    />
                </Right>
            </Container>
        </Page>
    )
}

export default Comp